export default __webpack_public_path__ + "static/media/BLE_TEMP.4743adf5.png";